import styled, { css, keyframes } from "styled-components";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";

export const StyledGrid = styled(Grid)(
    () => css`
        > * {
            &:nth-child(n + 3) {
                & .MuiInputLabel-root {
                    /* padding-left: 28px; */
                }
                & .MuiInput-root {
                    /* padding-left: 28px; */
                }
            }
        }
    `
);

const opencloseAnimation = keyframes`
  0% { top: 0.2rem; width: 0; }
  5% { width: 0; }
  15% { width: 230px; }
  30% { top: 0.2rem; width: 230px; }
  33% { top: 0.2rem; width: 0; }
  35% { top: 0.2rem; width: 0; }
  38% { top: -4.5rem; }
  48% { top: -4.5rem; width: 190px; }
  62% { top: -4.5rem; width: 190px; }
  66% { top: -4.5rem; width: 0; text-indent: 0; }
  71% { top: -9rem; width: 0; text-indent: 5px; }
  86% { top: -9rem; width: 285px; }
  95% { top: -9rem; width: 285px; }
  98% { top: -9rem; width: 0; text-indent: 5px; }
  100% { top: 0; width: 0; text-indent: 0; }
`;

export const MessageWrapper = styled.div`
    color: #fff;
    font-size: 3rem;
    line-height: 1.5;
    overflow: hidden;
    position: relative;
    min-width: auto;
    top: 0;
    right: 0;
    min-height: 75px;
    width: 137px;
    display: block;
    float: left;

    html.lang-de & {
        width: 175px;
    }

    @media (max-width: 767px) {
        display: none;
    }

    @media (max-width: 1024px) {
        display: none;
    }
`;

export const AnimatedMessage = styled.div`
    background-color: #ad72e755;
    color: #fff;
    display: block;
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    animation: ${opencloseAnimation} 7s linear infinite;
`;

export const SubMessage = styled.span`
    display: block;
    font-weight: lighter;
`;

export const SubMessageTop = styled.span`
    line-height: 70px;

    @media (max-width: 767px) {
        line-height: normal;
    }
`;

export const SubMessageParticle = styled.span`
    display: none;
    @media (max-width: 767px) {
        display: block;
    }

    @media (max-width: 1024px) {
        display: block;
        display: inline-block;
        margin-right: 5px;
    }
`;

export const SubMessageBottom = styled.span`
    text-align: left;
    float: left;
    width: 100%;
    margin-bottom: 35px;
    @media (max-width: 767px) {
        float: none;
    }
`;

export const Button = styled.a`
    display: block;
    width: 100%;
    border-radius: 2em;
    background-color: #1fc2ff;
    color: #fff;
    outline: none;
    border: none;
    padding: 12.5px 0;
    margin-bottom: 0.5em;
    text-align: center;
    text-decoration: none;
    font-size: 1em;
    font-weight: bold;
    cursor: pointer;
    transition: transform 0.8s,
        background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
        border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
        0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    &:hover {
        box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
            0px 4px 5px 0px rgba(0, 0, 0, 0.14),
            0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    }
    @media (min-width: 767px) {
        width: 50%;
    }
`;

export const ButtonGoogle = styled.a`
    display: inline-block;
    width: 2em;
    height: 2em;
    background-image: url(/images/google-button.svg);
    background-repeat: no-repeat;
    outline: none;
    border: none;
    margin: 1em 1em;
    text-align: center;
    text-decoration: none;
    font-size: 1em;
    cursor: pointer;
`;

export const ButtonFacebook = styled.a`
    display: inline-block;
    width: 2em;
    height: 2em;
    background-image: url(/images/facebook-button.svg);
    background-repeat: no-repeat;
    color: #fff;
    outline: none;
    border: none;
    margin: 1em 1em;
    text-align: center;
    text-decoration: none;
    font-size: 1em;
    cursor: pointer;
`;

export const TendbeSVG = styled.img`
    display: none;
    margin: auto;
    z-index: 3;
    height: 84%;

    /* Portrait and Landscape */
    @media only screen and (min-device-width: 375px) and (max-device-width: 767px) and (-webkit-min-device-pixel-ratio: 3) {
        display: block;
        transform: scale(2);
    }
    /* Portrait */
    @media only screen and (min-device-width: 375px) and (max-device-width: 767px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait) {
        display: block;
        transform: scale(2);
    }
    /* Landscape */
    @media only screen and (min-device-width: 375px) and (max-device-width: 767px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
        display: block;
        transform: scale(2);
    }

    /* ----------- iPad 1, 2, Mini and Air ----------- */

    /* Portrait and Landscape */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    }

    /* Portrait */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
    }

    /* Landscape */
    @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
    }

    @media (min-width: 375px) and (max-width: 767px) {
        display: block;
        transform: scale(2.5);
    }
    @media (min-width: 1024px) and (max-width: 1366px) {
        margin-left: 0;
    }
`;

export const TendbeWorld = styled.div`
    z-index: 3;
    background-image: url(/images/tendbe-world-c.svg);
    background-repeat: no-repeat;
    top: 1vh;
    position: relative;
    width: 100%;

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 767px) {
        background-position: bottom right;
    }

    /* Desktops and laptops ----------- */
    @media only screen and (min-width: 1224px) {
        background-position: bottom 100%;
        background-size: 60%;
        width: 100%;
        height: 100%;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin-top: 1.6em;
    flex: 1 1 auto;

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 767px) {
        flex-direction: row;
        width: 100%;
    }

    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
    }

    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
    }

    @media (min-width: 1366) and (max-width: 1900px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 90vw;
        box-sizing: border-box;
    }

    @media (min-width: 1920px) {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 70vw;
        box-sizing: border-box;
    }
`;

export const ContainerForgotPassWord = styled.div`
    display: flex;
    align-items: center;
    height: inherit;
    width: 100%;
    box-sizing: border-box;
    font-size: 12px;

    justify-content: center;
    flex-wrap: wrap;
    .Forgot-password {
        color: #1fc2ff;
    }
    .forgot {
        color: #fff;
        margin: 0;
    }

    @media (min-width: 767px) {
        justify-content: flex-start;
    }
`;

export const ContainerSocialLogin = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    height: inherit;
    width: 100%;
    box-sizing: border-box;
    @media (max-width: 767px) {
        justify-content: center;
    }
`;

export const Content = styled.div`
    width: 100%;
    max-width: 480px;
    text-align: left;
    z-index: 4;

    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 767px) {
        margin: 1em 3em;
        padding-top: 80px;
    }

    @media (max-width: 767px) {
        margin-bottom: 3em;
        text-align: center;
    }

    @media (min-width: 1366px) {
        position: absolute;
        left: 11%;
        margin: 0;
    }
`;

export const Paragraph = styled.p`
    color: #fff;
    font-size: 1em;
    padding-left: 0.2em;
`;

export const Description = styled.p`
    color: #fff;
    font-size: 1em;
    font-weight: 300;
    line-height: 1.5;
    margin: 0;
    @media (min-width: 1024px) {
        font-size: 1.3em;
    }
`;

export const DescriptionBold = styled.p`
    color: #fff;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.2;
    @media (min-width: 1024px) {
        font-size: 1.3em;
    }
`;

export const DescJoin = styled.p`
    color: #fff;
    font-size: 1em;
    font-weight: bold;
    line-height: 1.2;
    @media (min-width: 1024px) {
        font-size: 1.3em;
    }

    @media only screen and (max-width: 600px) {
        display: none;
    }
`;

export const Divider = styled.div`
    width: 100%;
    height: 10px;
    position: absolute;
    top: 0%;
    margin-bottom: 0.5em;
    background-color: rgb(68, 220, 255);
    background-image: -moz-linear-gradient(
        90deg,
        rgba(250, 47, 92, 1) 0%,
        rgba(202, 88, 239, 1) 50%,
        rgba(68, 220, 255, 1) 100%
    );
    background-image: -webkit-linear-gradient(
        90deg,
        rgba(250, 47, 92, 1) 0%,
        rgba(202, 88, 239, 1) 50%,
        rgba(68, 220, 255, 1) 100%
    );
    background-image: linear-gradient(
        90deg,
        rgba(250, 47, 92, 1) 0%,
        rgba(202, 88, 239, 1) 50%,
        rgba(68, 220, 255, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f63167",endColorstr="#50cfff",GradientType=1);
`;

export const LoadingOverlay = styled.div`
    background-color: #334768;
    display: block;
    max-width: 100vw;
    min-height: 100vh;
    overflow-x: hidden;
    position: absolute;
`;

export const Hero = styled.div`
    background-image: url(/images/background.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    display: flex;
    flex-direction: column;
    flex: 1 1 100%;
    justify-content: flex-start;
    align-items: center;
    height: 100vh;
    background-clip: padding-box;
    box-sizing: border-box;
`;

export const ParentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    height: calc(100vh - 40px);

    @media (max-width: 768px) {
        height: inherit;
    }
`;

export const StyledLink = styled(Link)`
    color: #fff;
    text-align: center;
    text-decoration: underline;
    text-decoration-color: transparent;
    transition: 0.3s;

    /*add those for opera and mozilla support*/
    -webkit-text-decoration-color: transparent;
    -moz-text-decoration-color: transparent;
    &:hover {
        text-decoration-color: inherit;

        /*add those for opera and mozilla support*/
        -webkit-text-decoration-color: inherit;
        -moz-text-decoration-color: inherit;
    }
`;

export const Logo = styled.img`
    width: 100%;
`;

export const LogoWrapper = styled.figure`
    margin: 0;
    padding: 0;
    width: 150px;
    margin-bottom: 3em;
    @media (min-width: 1024px) {
        display: none;
    }
`;

export const SignIn = styled.div`
    display: block;
    width: 100%;
    min-width: 320px;
    max-width: 400px;
`;

export const SignInContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: 1.2em;
    box-sizing: border-box;
`;

export const Title = styled.h1`
    color: #fff;
    font-size: 2em;
    font-family: Roboto;
    font-weight: bold;
    @media (min-width: 1024px) {
        font-size: 3.1em;
    }
    @media (max-height: 650px) {
        font-size: 1.8em;
    }
`;

export const FooterMenu = styled.footer`
    width: 100%;
    z-index: 10;
    background-color: #384a72;
    color: #fff;

    .ft-menu-list {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            padding: 0.5em;
            text-align: center;
            a {
                text-decoration: none;
                color: #fff;
                display: block;
                height: 100%;
                width: 100%;
            }
        }

        .ft-menu-item {
            cursor: pointer;
            transition: all 0.3s ease;
            &:hover {
                background-color: #fff;
                color: #384a72;

                a {
                    color: #384a72;
                }
            }
            @media screen and (min-width: 414px) {
                padding: 8px 16px;
            }
        }

        @media screen and (min-width: 414px) {
            display: flex;
            justify-content: flex-end;
        }
    }
`;
